import {
  setProfileFail,
  setProfileLoading,
  setProfileSuccess,
  setUserNotificationCountLoading,
  setUserNotificationCountSuccess,
  setUserNotificationCountFail,
  setFamilyMembersLoading,
  setFamilyMembersSuccess,
  setFamilyMembersFail,
  setPendingFriendRequestsCountLoading,
  setPendingFriendRequestsCountSuccess,
  setPendingFriendRequestsCountFail,
} from "store/reducers/Profile/profile";

export const setProfile = (profile) => async (dispatch) => {
  try {
    dispatch(setProfileLoading());
    dispatch(setProfileSuccess(profile));
  } catch (error) {
    console.error(error);
    dispatch(setProfileFail("Failed to set user profile "));
  }
};
export const updateUserNotificationCount = (count) => async (dispatch) => {
  try {
    dispatch(setUserNotificationCountLoading());
    dispatch(setUserNotificationCountSuccess(count));
  } catch (error) {
    console.error(error);
    dispatch(
      setUserNotificationCountFail("Failed to set user notification count ")
    );
  }
};
export const setFamilyMembers = (familyMembers) => async (dispatch) => {
  try {
    dispatch(setFamilyMembersLoading());
    dispatch(setFamilyMembersSuccess(familyMembers));
  } catch (error) {
    console.error(error);
    dispatch(setFamilyMembersFail("Failed to set user family members "));
  }
};

export const updatePendingFriendRequestCount = (count) => async (dispatch) => {
  try {
    dispatch(setPendingFriendRequestsCountLoading());
    dispatch(setPendingFriendRequestsCountSuccess(count));
  } catch (error) {
    console.error(error);
    dispatch(
      setPendingFriendRequestsCountFail(
        "Failed to updated pending friend requests count "
      )
    );
  }
};
